import { css, useTheme } from '@emotion/react';

const useStyle = () => {
  const theme = useTheme();
  const { secondary } = theme.palette;

  const bannerWrapper = css`
    width: 100%;
    background: ${secondary.light};
    padding: 20px 25px;
    display: flex;
    justify-content: center;
    text-align: center;
  `;

  return { bannerWrapper };
};

export default useStyle;
